import toast from 'react-hot-toast'

import { showApiError, useMutation, useQueryClient } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'

import { loadKeys } from '@/hooks/shipments/useLoad'
import type { ClientCreateCustomerRoutedLoadInput } from '@/types'
import { shipperFetch } from '@/utils/shipperFetch'

const createCustomerRoutedLoad = async (
  dto: ClientCreateCustomerRoutedLoadInput,
) =>
  shipperFetch<FullShipment[]>('/shipments/customer-routed', {
    method: 'POST',
    body: dto,
  })

export function useCreateCustomerRoutedLoad() {
  const queryClient = useQueryClient()

  return useMutation(createCustomerRoutedLoad, {
    onSettled: (shipments, error) => {
      if (error) return showApiError('Unable to create shipment', error)

      shipments?.forEach(s => {
        queryClient.setQueryData(loadKeys.id(s.loadId), s)
      })

      queryClient.invalidateQueries({ queryKey: ['shipments'] })
      toast.success('Shipment created successfully.')
    },
  })
}
